import { CommentsoldIntegrationProduct } from "@redotech/redo-model/commentsold";
import * as z from "zod/v4";

export const deleteCommentsoldIntegration = {
  name: "deleteCommentsoldIntegration" as const,
  input: z.object({ product: z.enum(CommentsoldIntegrationProduct) }),
  output: z.void(),
};
